import { render, staticRenderFns } from "./SpecialDataManage.vue?vue&type=template&id=d89d0518&"
import script from "./SpecialDataManage.vue?vue&type=script&lang=js&"
export * from "./SpecialDataManage.vue?vue&type=script&lang=js&"
import style0 from "./SpecialDataManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports